import { createFileRoute } from '@tanstack/react-router';

// relative imports
import LoadingPage from '../../components/shared/page-components/LoadingPage';
import UserProfilePage from '../../components/shared/user-profile/UserProfilePage';

export const Route = createFileRoute('/_authenticated/user-settings')({
  component: UserProfilePage,
  pendingComponent: () => (
    <LoadingPage loadingPage accountOptional hideSecondaryMenu />
  ),
  staticData: {
    hideSecondaryMenu: true,
    hideAccountMenu: true,
    accountOptional: true,
    meta: {
      title: 'User Settings | Ledgible',
    },
  },
});
